import { FC, useState, useEffect } from 'react'
import styles from '../../styles/admin/StudyContent.module.scss'
import { Checkbox } from '@mantine/core'
import ImageDropzone from './ImageDropzone'
import FractionQuestionInput from './FractionQuestionInput'
import AnswerImageDropzone from './AnswerImageDropZone'

interface CorrectAnswerMultipleProps {
  values?: string[]
  onValuesChange?: (values: string[]) => void
  checkedStates?: boolean[]
  onCheckedStatesChange?: (states: boolean[]) => void
  placeholder?: string
  answerType?: 'text' | 'image'
  imageFiles?: (File | null)[]
  onImageFilesChange?: (files: (File | null)[]) => void
  existingImageUrls?: string[]
  className?: string
  label?: string
  count?: number
}

const CorrectAnswerMultiple: FC<CorrectAnswerMultipleProps> = ({
  values = ['', '', '', '', ''],
  onValuesChange = () => {},
  checkedStates = [false, false, false, false, false],
  onCheckedStatesChange = (states: boolean[]) => {},
  placeholder = '답을 입력하세요',
  answerType = 'text',
  imageFiles = [null, null, null, null, null],
  onImageFilesChange = () => {},
  existingImageUrls = [],
  className,
  label = 'Answer (120x80)',
  count = 5,
}) => {
  // ✅ 로컬 상태 추가!
// ✅ 초기값만 세팅하고 useEffect 제거
  const [localImageUrls, setLocalImageUrls] = useState<string[]>(() => existingImageUrls)

  // ✅ props 변경시 동기화
  useEffect(() => {
    setLocalImageUrls(existingImageUrls)
  }, [JSON.stringify(existingImageUrls)])

  // ✅ 이미지 삭제 핸들러
  const handleRemove = (index: number) => {
    const updated = [...localImageUrls]
    updated[index] = ''
    setLocalImageUrls(updated)
  }

  const handleMultipleChange = (index: number, newValue: string) => {
    const updatedValues = [...values]
    updatedValues[index] = newValue
    onValuesChange(updatedValues)
  }

  const handleImageChange = (index: number, file: File | null) => {
    const updatedFiles = [...imageFiles]
    updatedFiles[index] = file
    onImageFilesChange(updatedFiles)
  }

  const handleCheckboxChange = (index: number) => {
    const updatedStates = new Array(count).fill(false)
    updatedStates[index] = true
    onCheckedStatesChange(updatedStates)
  }

  const adjustedValues = values.slice(0, count)
  while (adjustedValues.length < count) {
    adjustedValues.push('')
  }

  const adjustedImageFiles = imageFiles.slice(0, count)
  while (adjustedImageFiles.length < count) {
    adjustedImageFiles.push(null)
  }

  const adjustedCheckedStates = checkedStates.slice(0, count)
  while (adjustedCheckedStates.length < count) {
    adjustedCheckedStates.push(false)
  }

  return (
    <div className={styles.correctAnswerContainer}>
      <div className={styles.correctAnswerWrapper}>
        <p
          style={{
            fontSize: '15px',
            fontWeight: 700,
            color: '#111',
            marginLeft: '16px',
            position: 'relative',
            top: '0px',
          }}
        >
          Answer
        </p>

        {answerType === 'text' ? (
          <div className={styles.multipleAnswersContainer}>
            {adjustedValues.map((val, index) => (
              <div key={index} className={styles.answerItem}>
                <Checkbox
                  checked={adjustedCheckedStates[index]}
                  onChange={() => handleCheckboxChange(index)}
                  className={styles.correctCheckbox}
                  size="sm"
                />
                <span className={styles.answerNumber}>{index + 1}.</span>

                {val.trim().startsWith('/') ? (
                  <ImageDropzone
                    imageFile={imageFiles[index]}
                    onImageChange={(newFile: any) =>
                      handleImageChange(index, newFile)
                    }
                    existingImageUrl={localImageUrls[index]}
                    className={styles.correctAnswerImage}
                    placeholderText={`Answer Image ${index + 1}`}
                    iconSize={24}
                    onExistingImageRemove={() => handleRemove(index)}
                  />
                ) : (
                  <FractionQuestionInput
                    key={index}
                    value={val}
                    onChange={(newValue) =>
                      handleMultipleChange(index, newValue)
                    }
                    className={styles.correctAnswerInput}
                    label={`Answer ${index + 1}`}
                  />
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.multipleAnswersContainerImage}>
            {adjustedImageFiles.map((file, index) => (
              <div
                key={index}
                className={`${styles.answerItem} ${
                  answerType === 'image' ? styles.answerItemImage : ''
                }`}
              >
                <Checkbox
                  checked={adjustedCheckedStates[index]}
                  onChange={() => handleCheckboxChange(index)}
                  className={styles.correctCheckbox}
                  size="sm"
                />
                <span className={styles.answerNumber}>{index + 1}.</span>
                <AnswerImageDropzone
                  imageFile={file}
                  onImageChange={(newFile: any) =>
                    handleImageChange(index, newFile)
                  }
                  existingImageUrl={localImageUrls[index]} // ✅
                  className={className || styles.correctAnswerImage}
                  placeholderText={`Answer img ${index + 1}\n(120x80)`}
                  iconSize={24}
                  onExistingImageRemove={() => handleRemove(index)}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default CorrectAnswerMultiple
